export default [
  'siteId',
  'sensorId',
  'readingTypeId',
  'areaId',
  'modelId',
  'manufacturerId',
]
